module.exports = __webpack_public_path__ + "img/dream-journal_B095GS18CV.ff1de7af.jpg";